import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";

const categoriesAdapter = createEntityAdapter({
  sortComparer: (a, b) => a.name.localeCompare(b.name),
});

const initialState = categoriesAdapter.getInitialState();

export const categoriesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCategories: builder.query({
      query: () => "/category",
      validateStatus: (response, result) => {
        return response.status === 200 && !result.isError;
      },
      // transformResponse: (responseData) => {
      //   const loadedCategory = responseData.map((category) => {
      //     category.id = category._id;
      //     return category;
      //   });
      //   return categoriesAdapter.setAll(initialState, loadedCategory);
      // },
      providesTags: (result, error, arg) => {
        if (result?.ids) {
          return [
            { type: "Category", id: "LIST" },
            ...result.ids.map((id) => ({ type: "Category", id })),
          ];
        } else return [{ type: "Category", id: "LIST" }];
      },
    }),
    createCategory: builder.mutation({
      query: data => ({
        url: "/category/create",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [
        { type: "Category", id: "LIST" }
      ]
    }),
    updateCategory: builder.mutation({
      query: data => ({
        url: "/category/update",
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "Category", id: arg.id }
      ]
    }),
    deleteCategory: builder.mutation({
      query: ({ id }) => ({
          url: `/category/delete`,
          method: "DELETE",
          body: { id }
      }),
      invalidatesTags: (result, error, arg) => [
          { type: "Category", id: arg.id }
      ]
    }),
  }),
});

export const {
  useGetCategoriesQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
} = categoriesApiSlice

// returns the query result object
export const selectCategoriesResult = categoriesApiSlice.endpoints.getCategories.select()

// creates memoized selector
const selectCategoriesData = createSelector(
  selectCategoriesResult,
  categoriesResult => categoriesResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
  selectAll: selectAllCategories,
  selectById: selectCategoryById,
  selectIds: selectCategoryIds
  // Pass in a selector that returns the products slice of state
} = categoriesAdapter.getSelectors(state => selectCategoriesData(state) ?? initialState)
